import { render, staticRenderFns } from "./index.vue?vue&type=template&id=429734a6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('429734a6')) {
      api.createRecord('429734a6', component.options)
    } else {
      api.reload('429734a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=429734a6&", function () {
      api.rerender('429734a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/DevProjectLayout/index.vue"
export default component.exports